const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';
import ImageControl from '../wp-controlers/mediaUpload';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    plansName,
    variant,
  } = attributes;

  return (
    <InspectorControls>
      {/* <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            {
              label: 'Default',
              value: 'default',
            },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />
      </PanelBody> */}

      <PanelBody title="Atributos da Logo" initialOpen={true}>
        <SelectControl
          label="Selecione o plano desejado"
          title="Selecione o plano desejado"
          value={plansName}
          options={[
            { label: 'DIRECTV GO', value: 'directvgo'},
            { label: 'GloboPlay', value: 'globoplay' },
            { label: 'Roku', value: 'roku' },
            { label: 'Paramount +', value: 'paramount'},
            { label: 'HBO Max', value: 'hbo'},
            { label: 'Premiere', value: 'premiere'}

          ]}
          onChange={(position) => setAttributes({ plansName: position })}
        />
      </PanelBody>

      <PanelBody title="Atributos da imagem" initialOpen={true}>
        <ImageControl
          image="sideImage"
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;